var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tip"},_vm._l((_setup.data),function(it){return _c('div',{key:it.img,staticClass:"tip-item"},[_c('img',{attrs:{"src":it.img}}),_c('span',{staticClass:"text"},[_vm._v(_vm._s(it.text))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }